
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SearchRow extends Vue {

  @Prop({ default: "" })
  public title: string;

  public search: string = "";

  public searchFn() {
    this.$emit("update-search", { search : this.search});
  }

  private enterKeyPress(e) {
        if (e.keyCode === 13) {
            this.searchFn();
        }
    }
}
